export default function (/*server*/) {
  /*
    Not the real default, see user.js for reference
  */
}
